export default {
  sections: {
    order_summary: 'Bestellingsoverzicht',
  },
  labels: {
    add_items: 'Voeg items toe om te beginnen',
    item_count_one: '{{count}} item',
    item_count_other: '{{count}} items',
  },
  buttons: {
    return: 'Terug',
  },
  tip: 'Fooi',
};
